import { assign, without, isEmpty } from 'lodash';
import { addFilter } from '@wordpress/hooks';
import { createHigherOrderComponent } from '@wordpress/compose';
import { Fragment } from '@wordpress/element';
import { InspectorAdvancedControls } from '@wordpress/block-editor';
import { __ } from '@wordpress/i18n';
import { ToggleControl, BaseControl } from '@wordpress/components';

// Enable Responsive disply control on the following blocks
const enabledBlocks = []; // [ 'gutenify/button', 'gutenify/buttons' ];

const addAttributes = ( settings, name ) => {
	// Do nothing if it's another block than our defined ones.
	if ( ! enabledBlocks.includes( name ) ) {
		return settings;
	}

	// Use Lodash's assign to gracefully handle if attributes are undefined
	settings.attributes = assign( settings.attributes, {
		responsiveDisplay: {
			type: 'array',
			default: [],
		},
	} );

	return settings;
};

addFilter( 'blocks.registerBlockType', 'extend-block-example/attribute/spacing', addAttributes );

const devices = [ {
	label: __( 'Desktop' ),
	name: 'desktop',
}, {
	label: __( 'Tablet' ),
	name: 'tablet',
}, {
	label: __( 'Mobile' ),
	name: 'mobile',
} ];

/**
 * Create HOC to add spacing control to inspector controls of block.
 */
const withSpacingControl = createHigherOrderComponent( ( BlockEdit ) => {
	return ( props ) => {
		// Do nothing if it's another block than our defined ones.
		if ( ! enabledBlocks.includes( props.name ) ) {
			return (
				<BlockEdit { ...props } />
			);
		}

		const { responsiveDisplay, className } = props.attributes;
		// useEffect( () => {
		// 	const _classes = className.split( ' ' );
		// 	if ( ! isEmpty( _classes ) ) {
		// 		forEach( _classes, function( value ) {
		// 			console.log( value );
		// 		} );
		// 	}
		// }, [ className ] );

		if ( isEmpty( className ) ) {
			props.attributes.className = '';
		}
		return (
			<Fragment>
				<BlockEdit { ...props } />
				<InspectorAdvancedControls>
					<BaseControl id="textarea-1" label={ __( 'Hide on specific device' ) }>
						{ devices.map( ( device ) => {
							return <Fragment key={ `${ device.name }` }>
								<ToggleControl
									label={ `${ __( 'Hide on' ) } ${ device.label }` }
									help={ responsiveDisplay.includes( device.name ) ? `${ __( 'Hidden on' ) } ${ device.label }` : '' }
									checked={ responsiveDisplay.includes( device.name ) }
									onChange={ ( value ) => {
										let values = [
											...responsiveDisplay,
											device.name,
										];
										let classes = props.attributes.className;
										if ( ! value ) {
											values = without( responsiveDisplay, device.name );
											const _classes = without( classes.split( ' ' ), `hide-on-${ device.name }`, 'undefined' );
											classes = _classes.join( ' ' );
										} else {
											classes = props.attributes.className + ` hide-on-${ device.name }`;
										}
										props.setAttributes( {
											responsiveDisplay: [ ...values ],
											className: classes,
										} );
									} }
								/></Fragment>;
						} ) }
					</BaseControl>
				</InspectorAdvancedControls>
			</Fragment>
		);
	};
}, 'withSpacingControl' );

addFilter( 'editor.BlockEdit', 'extend-block-example/with-spacing-control', withSpacingControl );
